import React, { useContext } from 'react';
import classNames from 'classnames';

import Checkbox from '../../checkbox/Checkbox';
import TableHead from '../TableHead';
import TableHeading from '../TableHeading';
import Text from '../../text/Text';
import TableRow from '../TableRow';
import { TableHeadingItem } from '../component/TableHeadingItem';
import { CheckType, Column, Row } from '../component/types';
import { TableContext } from './provider/Provider';

interface Props<T> {
  isStickyHeader: boolean;
  check: CheckType;
  isShowColumnHeader: boolean;
  columns: Column<T>[];
  activePage: number;
}

function TableHeadView<T extends Row>({
  isStickyHeader,
  check,
  isShowColumnHeader,
  columns,
  activePage,
}: Props<T>) {
  const { selectedIdsData, onCheckedAll } = useContext(TableContext);
  return (
    <TableHead
      className={classNames({
        'position-sticky top-0 z-1': isStickyHeader,
      })}
    >
      <TableRow>
        {check && !check?.isHideCheckbox ? (
          <TableHeading className={classNames({ specific: !check?.label })}>
            {check?.label ? (
              <Text color="subtitle1" size="sm" weight="medium">
                {check.label}
              </Text>
            ) : (
              <Checkbox
                id="all"
                name="all"
                controlling
                value="all"
                checked={selectedIdsData[activePage]?.active}
                onChange={onCheckedAll}
              />
            )}
          </TableHeading>
        ) : null}

        {isShowColumnHeader
          ? columns?.map((column) =>
              !column.hide ? (
                <TableHeading
                  key={column.id}
                  className={classNames({
                    'sticky-th': column?.fixedPosition,
                  })}
                  {...(column?.fixedPosition && {
                    style: {
                      width: column?.fixedPosition?.width,
                      maxWidth: column?.fixedPosition?.width,
                      minWidth: column?.fixedPosition?.width,
                      left: column?.fixedPosition?.left,
                      right: column?.fixedPosition?.right,
                    },
                  })}
                >
                  <TableHeadingItem item={column} />
                </TableHeading>
              ) : null,
            )
          : null}
      </TableRow>
    </TableHead>
  );
}

export default TableHeadView;
